<template>
  <div class="edit">
    <h1>Houtsoort types</h1>

    <form class="default-form edit-form" @submit.prevent="">

      <div class="default-form-field">

        <div class="default-form-field-types row" style="flex-direction: row; text-align: left;">
          <span class="item row-header">Naam</span>
          <span class="item row-header"></span>

          <div v-for="(houtsoort, i) in houtsoortTypes" :key="i" class="default-form-field-types-edit-row row">
            <div class="item">
              <input type="text" class="default-form-field-input item" :id="'input' + i" v-model.trim="houtsoort.name" @keydown.enter="add(i + 1)">
            </div>

            <button class="default-form-field-button item" @mousedown="remove(i)" >
              <mdicon name="minus" class="default-form-field-button-icon" size="25" />
            </button>
          </div>

          <button class="default-form-field-button" @click="add(houtsoortTypes.length)">
            <mdicon name="plus" class="default-form-field-button-icon" size="25" />
          </button>
        </div>
      </div>

      <div class="default-form-button">
        <LoadingButton @click="update()" :loading="loading" :disabled="!formValid">Update</LoadingButton>
      </div>

    </form>
  </div>
</template>

<script>
import isEqual from 'lodash.isequal'
import { mapGetters } from 'vuex'
import LoadingButton from '@/components/inputs/buttons/LoadingButton.vue'

export default {
  name: "HoutsoortTypes",

  components: {
    LoadingButton
  },

  data () {
    return {
      houtsoortTypes: [],
      formValid: false,
      loading: false,
    }
  },

  methods: {
    async get () {
      await Promise.all([
        this.$store.dispatch('getHoutsoortTypes'),
        this.$store.dispatch('getTextures'),
      ])
      this.houtsoortTypes = JSON.parse(JSON.stringify(this.data))
    },

    async update () {
      this.loading = true

      let remove = []
      let update = []
      let insert = []

      for (let i = 0; i < this.data.length; i++) {
        const keepId = this.houtsoortTypes.find((t) => t.id === this.data[i].id)
        if (!keepId) {
          // houtsoortType is removed
          remove.push(this.data[i])
        } else {
          const houtsoortTypeChanged = this.houtsoortTypes.find((t) => t.id === this.data[i].id && JSON.stringify(t) !== JSON.stringify(this.data[i]))
          if (houtsoortTypeChanged) {
            // houtsoortType is changed
            update.push(houtsoortTypeChanged)
          }
        }
      }

      for (let i = 0; i < this.houtsoortTypes.length; i++) {
        if (!this.houtsoortTypes[i].id) {
          insert.push(this.houtsoortTypes[i])
        }
      }

      try {
        await this.$store.dispatch('updateHoutsoortTypes', {
          remove: remove,
          update: update,
          insert: insert
        })
      } catch (err) {
        console.log(err)
        this.loading = false
      }

      this.loading = false
      this.houtsoortTypes = JSON.parse(JSON.stringify(this.data))
    },

    add (i) {

      if (i === this.houtsoortTypes.length) {
        this.houtsoortTypes.push({
          id: null,
          name: "",
          label: "",
          description: "",
          uiImage: "",
          textLeft: "",
          textRight: "",
          colors: []
        })
      }

      this.$nextTick(() => {
        document.getElementById('input' + (i)).focus()
      })
    },

    remove (i) {
      this.houtsoortTypes.splice(i, 1)
    },

    addColor (houtsoortIndex) {
      if (!this.houtsoortTypes[houtsoortIndex].colors) {
        this.houtsoortTypes[houtsoortIndex].colors = []
      }
      this.houtsoortTypes[houtsoortIndex].colors.push({
        label: "",
        hexcode: "",
        uiHexcode: "",
        artikelCode: ""
      })
    },

    removeColor (houtsoortIndex, colorIndex) {
      this.houtsoortTypes[houtsoortIndex].colors.splice(colorIndex, 1)
    },

    updateIsDefault (houtsoort) {
      // Reset all isDefault to false except the one that was just clicked
      this.houtsoortTypes.forEach(f => {
        if (f !== houtsoort) {
          f.isDefault = false
        }
      })
    },

    updateIsDefaultColor (houtsoortIndex, colorIndex) {
      // Reset all isDefault to false except the one that was just clicked
      this.houtsoortTypes[houtsoortIndex].colors.forEach((c, i) => {
        if (i !== colorIndex) {
          c.isDefault = false
        }
      })
    }
  },

  computed: {
    ...mapGetters({
      data: "getHoutsoortTypes",
      textures: 'getTextures',
    }),

    texturesWithEmpty () {
      return [{ id: null, name: '(leeg)' }, ...this.textures]
    },
  },

  created () {
    this.get()
  },

  watch: {
    houtsoortTypes: {
      deep: true,
      immediate: false,
      handler () {
        if (isEqual(this.houtsoortTypes, this.data)) {
          this.formValid = false
        } else {
          this.formValid = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit {
  display: flex;
  flex-direction: column;
  padding: 25px;
  align-items: center;
  min-width: min(100%, 800px);

  &-form {
    padding: 25px 0px;
    gap: 50px;
    width: 300px;
  }
}

.row {
  display: flex;
  flex-wrap: wrap; /* Allow items to wrap if needed */
  width: 100%; /* Adjust as necessary */
  &-header {
    padding-left: 5px;
    justify-content: left !important;
  }
}

.item {
  flex: 1; /* Default flex property for other items */
  width: 0px; // dit werkt op een of andere manier
  box-sizing: border-box; /* Include padding and border in width */
  display: flex;
  align-items: flex-start;
  &:nth-child(2) {
    flex: 0 0 30px; /* Fixed width of 70px */
  }
}

.colors-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.colors-section {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-width: 100%;
}

.colors-header {
  display: flex;
  gap: 10px;
  margin-bottom: 5px;
}

.color-header-item {
  flex: 1;
  // font-size: 12px;
  // font-weight: bold;
  // padding: 5px;
  // text-align: center;
  &:last-child {
    flex: 0 0 30px;
  }
  padding-left: 5px;
  justify-content: left !important;
}

.color-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.color-input {
  flex: 1;
  min-width: 0;
}

.color-delete-btn {
  flex: 0 0 30px;
  height: 30px;
  padding: 2px;
}

.add-color-btn {
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  font-size: 12px;
}

</style>